import { withSignal, CommonEventParser } from '@bingads-webui-react/hoc-with-signal';
import {
  PrimaryButton as FabricPrimaryButton,
  DefaultButton as FabricDefaultButton,
  Link as FabricLink,
  TextField as FabricTextField,
  IconButton as FabricIconButton,
} from '@bingads-webui-react/fabric-control';

export const PrimaryButton = withSignal(FabricPrimaryButton, {
  onClick: CommonEventParser,
});

export const DefaultButton = withSignal(FabricDefaultButton, {
  onClick: CommonEventParser,
});

export const Link = withSignal(FabricLink, {
  onClick: CommonEventParser,
});

export const TextField = withSignal(FabricTextField, {
  onChange: CommonEventParser,
});

export const IconButton = withSignal(FabricIconButton, {
  onClick: CommonEventParser,
});
